import React from 'react';
export function Footer() {
  return <footer className="py-12 bg-background border-t border-white/5 text-center" data-id="element-94">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-95">
        <div className="mb-8" data-id="element-96">
          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-97">
            🛡️ MEGA PACK AUTO BLINDADO™
          </h3>
          <p className="text-cyan font-medium mb-2" data-id="element-98">
            El sistema N°1 para dueños de auto usado en Argentina.
          </p>
          <p className="text-gray-400" data-id="element-99">
            Porque manejar no debería costarte todos los meses del año en
            sorpresas, multas y mecánicos que te pasan por arriba.
          </p>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-gray-400 text-sm mb-12" data-id="element-100">
          <a href="mailto:soporte@autoblindado.com" className="hover:text-cyan transition-colors" aria-label="Enviar correo a soporte" data-id="element-101">
            📧 soporteoficialfegion@gmail.com
          </a>
          <span className="hidden md:inline text-white/10" aria-hidden="true" data-id="element-102">
            |
          </span>
          <a href="#" className="hover:text-cyan transition-colors" aria-label="Instagram de Fegion" data-id="element-103">
            📲 @fegion
          </a>
          <span className="hidden md:inline text-white/10" aria-hidden="true" data-id="element-104">
            |
          </span>
          <a href="#" className="hover:text-cyan transition-colors" aria-label="Sitio web de Fegion" data-id="element-105">
            🌐 www.fegion.shop
          </a>
        </div>

        <div className="border-t border-white/5 pt-8" data-id="element-106">
          <p className="text-gray-400 text-sm mb-6" data-id="element-107">
            © Mega Pack Auto Blindado™ 2026 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <div className="text-gray-400 text-sm italic space-y-1" data-id="element-108">
            <p data-id="element-109">🚗 "El próximo viaje puede ser diferente."</p>
            <p data-id="element-110">
              "Porque tu auto te lleva lejos — pero solo si lo blindás bien."
            </p>
          </div>
        </div>
      </div>
    </footer>;
}